module.exports = __webpack_public_path__ + "static/media/black_king.2e241341.svg";